import React from "react";
import hearderbg from "../Assest/new_logo_withshreebalaji.png"
import services from "../Compoemnt/ServiceDetails/servicesData";

export default function About() {
  return (
    <div className="text-gray-800 overflow-hidden">

      {/* HERO */}
      <section
        className="relative py-28 bg-cover bg-center"
        style={{
          backgroundImage: `url(${hearderbg})`,
        }}
      >
        {/* Dark overlay for readability */}
        {/* <div className="absolute inset-0 bg-black/60"></div> */}

        {/* Optional gradient overlay for premium feel */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#2C3E5C]/70 via-[#1F2A44]/60 to-[#000]/50"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white animate-fadeUp">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            About BINGOPAY
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-white/90">
            Building trust, technology and transparency in digital payments.
          </p>
        </div>
      </section>
      {/* PRODUCTS / SERVICES */}
      <section className="py-20 bg-gradient-to-b from-white to-slate-50">
        <div className="max-w-7xl mx-auto px-6 text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">
            We Are Offering Products & Banking Services
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            We provide reliable and secure digital banking and financial
            services designed to empower merchants across India.
          </p>
        </div>

        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;

            return (
              <div
                key={index}
                className="glass rounded-3xl p-8 shadow-xl
          hover:-translate-y-2 hover:shadow-2xl
          transition-all duration-300 text-center"
              >
                <div className="mb-4 flex justify-center">
                  <Icon className="text-4xl text-indigo-600" />
                </div>

                <h3 className="text-xl font-semibold mb-3 text-indigo-600">
                  {service.title}
                </h3>

                <p className="text-gray-600 leading-relaxed">
                  {service.desc}
                </p>
              </div>
            );
          })}
        </div>
      </section>


    </div>
  );
}
